import styled from 'styled-components';

const StyledModalContentAreaHeader = styled.div`
  font-weight: 700;
  font-size: 14px;

  color: ${props => props?.headerColor || '#264B9F'};
`;
export default StyledModalContentAreaHeader;
